import { useRef } from "react";
import css from "./index.module.css";

function ChatInput({
  value,
  onChange,
  onSend,
  onFile,
  disabled,
}: {
  value: string;
  onChange: (v: string) => void;
  onSend: () => void;
  onFile: (f: File) => void;
  disabled?: boolean;
}) {
  const fileRef = useRef<HTMLInputElement | null>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className={css.chatInputBar}>
      <input
        type="file"
        ref={fileRef}
        style={{ display: "none" }}
        accept="image/*"
        onChange={(e) => {
          if (e.target.files && e.target.files[0]) {
            onFile(e.target.files[0]);
            e.target.value = "";
          }
        }}
      />
      <textarea
        className={css.chatInputField}
        placeholder="Введите сообщение"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        rows={1}
        style={{ resize: "none" }}
      />
      <button
        className={css.chatInputFileBtn}
        type="button"
        onClick={() => fileRef.current?.click()}
        tabIndex={-1}
        disabled={disabled}
        aria-label="Отправить файл"
      >
        <i
          className="fi fi-rr-paperclip-vertical"
          style={{ position: "relative", top: 2 }}
        ></i>
      </button>

      <button
        className={css.chatInputSendBtn}
        onClick={onSend}
        disabled={disabled || !value.trim()}
        type="button"
        aria-label="Отправить"
      >
        <i className="fi fi-rr-paper-plane-top"></i>    
      </button>
    </div>
  );
}

export default ChatInput;